module.exports = __webpack_public_path__ + "media/img/frontend_application/footericon/instagram-754696d20303c836d0c17a3270ea06c3.svg";